import React, { memo, useCallback, useState } from 'react';
import classnames from 'classnames';
import styles from './Rate.module.less';

export default memo(props => {
  const { score, rateInfo } = props;
  const [hoverStarNum, setHoverStarNum] = useState(0); // hover选中的评分

  // const starArr = new Array(5);
  // starArr.fill('icon-staron', 0, starOnCount).fill('icon-star', starOnCount);

  // 鼠标hover进入星星
  const onHoverStar = useCallback(num => {
    if (rateInfo && rateInfo.isNeedClick) {
      setHoverStarNum(num);
    }
  }, []);

  const starOnCount = Math.floor(Number(parseFloat(score) + 0.5)) || 0;

  return (
    <span className={styles.rate}>
      <span
        star="1"
        className={classnames(
          'star',
          'iconfont',
          starOnCount >= 1 || hoverStarNum >= 1 ? 'icon-staron' : 'icon-star',
          rateInfo && rateInfo.staronColor === 'grey' ? 'star_grey' : '',
          (rateInfo && rateInfo.className) || '',
        )}
        onMouseOver={() => {
          onHoverStar(1);
        }}
        onMouseOut={() => {
          onHoverStar(0);
        }}
        onFocus={() => undefined}
      />
      <span
        star="2"
        className={classnames(
          'star',
          'iconfont',
          starOnCount >= 2 || hoverStarNum >= 2 ? 'icon-staron' : 'icon-star',
          rateInfo && rateInfo.staronColor === 'grey' ? 'star_grey' : '',
          (rateInfo && rateInfo.className) || '',
        )}
        onMouseOver={() => {
          onHoverStar(2);
        }}
        onMouseOut={() => {
          onHoverStar(0);
        }}
        onFocus={() => undefined}
      />
      <span
        star="3"
        className={classnames(
          'star',
          'iconfont',
          starOnCount >= 3 || hoverStarNum >= 3 ? 'icon-staron' : 'icon-star',
          rateInfo && rateInfo.staronColor === 'grey' ? 'star_grey' : '',
          (rateInfo && rateInfo.className) || '',
        )}
        onMouseOver={() => {
          onHoverStar(3);
        }}
        onMouseOut={() => {
          onHoverStar(0);
        }}
        onFocus={() => undefined}
      />
      <span
        star="4"
        className={classnames(
          'star',
          'iconfont',
          starOnCount >= 4 || hoverStarNum >= 4 ? 'icon-staron' : 'icon-star',
          rateInfo && rateInfo.staronColor === 'grey' ? 'star_grey' : '',
          (rateInfo && rateInfo.className) || '',
        )}
        onMouseOver={() => {
          onHoverStar(4);
        }}
        onMouseOut={() => {
          onHoverStar(0);
        }}
        onFocus={() => undefined}
      />
      <span
        star="5"
        className={classnames(
          'star',
          'iconfont',
          starOnCount >= 5 || hoverStarNum >= 5 ? 'icon-staron' : 'icon-star',
          rateInfo && rateInfo.staronColor === 'grey' ? 'star_grey' : '',
          (rateInfo && rateInfo.className) || '',
        )}
        onMouseOver={() => {
          onHoverStar(5);
        }}
        onMouseOut={() => {
          onHoverStar(0);
        }}
        onFocus={() => undefined}
      />
      {/* {starArr.map((v, i) => (
        <span className={classnames('star', 'iconfont', v)} key={i} />
      ))} */}
    </span>
  );
});
